import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Pages.css';

const BACKEND = 'https://resumify-production.up.railway.app';

export default function Success() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const sessionId = params.get('session_id');
  const payfast = params.get('payfast');

  useEffect(() => {
    if (!sessionId) { navigate('/'); return; }

    const verify = async () => {
      try {
        const res = await axios.get(
          `${BACKEND}/api/verify-payment/${sessionId}?payfast=${payfast || ''}`
        );
        if (res.data.paid) {
          setStatus('paid');
        } else {
          setStatus('pending');
        }
      } catch {
        setStatus('error');
      }
    };

    verify();
    const interval = setInterval(verify, 3000);
    return () => clearInterval(interval);
  }, [sessionId, payfast, navigate]);

  const handleDownload = () => {
    window.open(`${BACKEND}/api/download/${sessionId}`, '_blank');
  };

  return (
    <div className="page-wrap">
      <div className="page-card fade-up">
        {status === 'verifying' && (
          <>
            <div className="page-spinner" />
            <h2>Confirming payment...</h2>
            <p>Just a moment while we verify your payment.</p>
          </>
        )}
        {status === 'pending' && (
          <>
            <div className="page-spinner" />
            <h2>Processing payment...</h2>
            <p>Your payment is being confirmed. This usually takes a few seconds.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <div className="page-icon">🎉</div>
            <h2>Payment confirmed!</h2>
            <p>Your tailored CV is ready to download.</p>
            <button className="page-btn" onClick={handleDownload}>
              ⬇️ Download Your CV
            </button>
            <button className="page-btn-secondary" onClick={() => navigate('/')}>
              Tailor another CV
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="page-icon">⚠️</div>
            <h2>Verification issue</h2>
            <p>We couldn't verify your payment. Please contact support or try downloading directly.</p>
            <button className="page-btn" onClick={handleDownload}>
              Try Download Anyway
            </button>
            <button className="page-btn-secondary" onClick={() => navigate('/')}>
              Go home
            </button>
          </>
        )}
      </div>
    </div>
  );
}